import React from "react";
import Backdrop from "@mui/material/Backdrop";
import { Grid } from "react-loader-spinner";
import { styled } from "@mui/system";

const StyledBackdrop = styled(Backdrop)(() => ({
  zIndex: 220000000,
  color: "#fff",
}));

const StyledGrid = styled(Grid)(() => ({
  // Apply your desired styles here
  color: "#000",
}));

export default function Loading({ loading }) {
  return (
    <div>
      <StyledBackdrop open={loading}>
        <StyledGrid />
      </StyledBackdrop>
    </div>
  );
}
